import React from 'react';

import { SingleFieldFilterProvider } from './FilterFieldsManager';
import { FiltersDataManagerProvider } from './FiltersDataManager';
import { FiltersSettingsProvider } from './FiltersSettings';
import FiltersStateManager, { useStateManager } from './FiltersStateManager';
import FiltersRequiredManagerProvider from './FiltersRequiredManager/FiltersRequiredManagerProvider';

const defaultInitialValues = {};

export const Filters = ({
  children,
  controlled,
  initialValues = defaultInitialValues,
  onChange,
  onApply,
  emptyValues,
  initialDirty,
  favorites,
  onChangeFavorites,
  screen,
}) => {
  const {
    setFilterValue,
    setFilterValues,
    getFilterValue,
    getFilterEmptyValue,
    getFilterValues,
    onClearFilters,
    onApplyFilters,
    clear,
    dirty,
  } = useStateManager({
    controlled,
    initialValues,
    initialDirty,
    emptyValues,
    onChange,
    onApply,
  });

  return (
    <FiltersRequiredManagerProvider>
      <FiltersDataManagerProvider screen={screen}>
        <FiltersStateManager.Provider
          value={{
            setFilterValue,
            setFilterValues,
            getFilterValue,
            getFilterEmptyValue,
            getFilterValues,
            onApplyFilters,
            onClearFilters,
            clear,
            dirty,
          }}
        >
          <FiltersSettingsProvider
            favorites={favorites}
            onChangeFavorites={onChangeFavorites}
          >
            <SingleFieldFilterProvider>{children}</SingleFieldFilterProvider>
          </FiltersSettingsProvider>
        </FiltersStateManager.Provider>
      </FiltersDataManagerProvider>
    </FiltersRequiredManagerProvider>
  );
};

export default Filters;
